import { fill, t } from '@bms2/shared';
import type { RowDataAttributes } from './DetailList';
import styles from './ReadOnlyNote.module.css';

/**
 * 🔒 The sentence a page draws where the viewer may read it and may not change it
 * (piece 4; T2164): one wording, naming what the viewer may read, and where the
 * refusal turns on a named permission, one sentence after it saying which. A page
 * decides whether to draw it off its read's write answer (`writeGate`); this only says it.
 * 🔨 Every `data-*` attribute the caller passes lands on the paragraph verbatim.
 */
export interface ReadOnlyNoteProps extends RowDataAttributes {
  /** What the viewer may read, with its article: *the asset register*. */
  what: string;
  /** The permission sentence that follows, where the refusal turns on one. */
  needs?: string;
}

export function ReadOnlyNote({ what, needs, ...data }: ReadOnlyNoteProps) {
  const sentence = fill(t('readOnly.note'), { what });
  return <p className={styles.note} {...data}>{needs ? `${sentence} ${needs}` : sentence}</p>;
}
